import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import getArea from '@turf/area';

import GeneralInformation from '@App/components/BuildingDamages/GeneralInformation/GeneralInformation';
import CostGraph from '@App/components/BuildingDamages/CostGraph/CostGraph';
import CostTable from '@App/components/BuildingDamages/CostTable/CostTable';

import { useUserAreas } from '@utils/queries/user.queries';
import { Button } from '@nazka/nazka.mapframe.components';
import { calculateCostPerClass, calculateTotalDamage } from './building-damages.utils';
import CompareModeView from './CompareModeView/CompareModeView';
import DamagesWithUACDataPanel from './DamagesWithUACDataPanel/DamagesWithUACDataPanel';
import PEValueGraph from '../PEValueGraph/PEValueGraph';
import RiskDistributionGraph from '../RiskDistributionGraph/RiskDistributionGraph';
import Print from '../../../utils/Print/Print';

import './building-damages.styl';

function BuildingDamages() {
  const isCompareModeOn = useSelector(state => state.buildingDamages.isComparisonModeOn)
  const currentSelectedDamageLayer = useSelector(state => state.layerSelector.currentSelectedDamageLayer)
  const {
    features, totalBuildingCount, areaId, modelId, 
  } = currentSelectedDamageLayer;
  
  const totalDamage = calculateTotalDamage(currentSelectedDamageLayer?.features);
  const costPerClass = useMemo(() => calculateCostPerClass(features), [features]);
  const { data: userAreas } = useUserAreas();
  const selectedArea = userAreas?.find(area => area.id === areaId)
  const userSelectedMode = useSelector(state => state.maplibreMap.userSelectedMode);
  const [isPrintTriggered, setIsPrintTriggered] = useState(false)

  return (
    <div className="building-damages">
      <GeneralInformation
        area={selectedArea ? getArea(selectedArea.feature) : ''}
        totalDamage={totalDamage}
        totalBuildingCount={totalBuildingCount}
        totalBuildingsFloodedCount={features.length}
        damageParameterId={currentSelectedDamageLayer?.damageParameterId}
      />
      {isCompareModeOn ? (<CompareModeView />) : (
        <div>
          {userSelectedMode === 'River flood' ? (
            <div>
              {features.length > 0
                ? (
                  <div>
                    {modelId === 'uac' ? (
                      <DamagesWithUACDataPanel
                        totalDamage={totalDamage}
                        features={features}
                        costPerClass={costPerClass}
                        changeTriggerStatus={setIsPrintTriggered}
                      />
                    ) : (
                      <div>
                        <div className="building-damages__flash-flood__header__wrapper">
                          <div />
                          <h3 className="building-damages__header-text">
                            {userSelectedMode === 'Flash flood' ? 'Flash flood risk' : 'Costs per damage class'}
                          </h3>
                          <Button
                            css={{
                              borderRadius: '4px',
                              height: '40px',
                            }}
                            onClick={() => setIsPrintTriggered(true)}
                          >
                            Export
                          </Button>
                        </div>
                        <div className="building-damages__table-graph__wrapper">
                          <CostGraph data={costPerClass} totalDamage={totalDamage} width={380} />
                          <CostTable data={costPerClass} />
                        </div>
                      </div>
                    )}
             
                  </div>
                )
                : (
                  <span className="building-damages__no__flood__text">
                    No flooded
                    {currentSelectedDamageLayer.modelId === 'uac' ? ' features ' : ' buildings '}
                    detected
                  </span>
                )}
            </div>
          ) : (
            <div>
              {features.length > 0
                ? (
                  <div>
                    <div className="building-damages__flash-flood__header__wrapper">
                      <div />
                      <h3 className="building-damages__header-text flash-flood">
                        Flash flood risk
                      </h3>
                      <Button
                        css={{
                          borderRadius: '4px',
                          height: '40px',
                        }}
                        onClick={() => setIsPrintTriggered(true)}
                      >
                        Export
                      </Button>
                    </div>
                    
                    <div className="building-damages__table-graph__flash-flood__wrapper">
                      <div className="placeholder" />
                      <div className="building-damages__graph-title__wrapper">
                        <h3>Area flash flood risk</h3>
                        <PEValueGraph currentSelectedDamageLayer={currentSelectedDamageLayer} />
                      </div>
                      <div className="building-damages__graph-title__wrapper">
                        <h3>Building risk distribution</h3>
                        <RiskDistributionGraph currentSelectedDamageLayer={currentSelectedDamageLayer} />
                      </div>
                      
                    </div>
                  </div>
                )
                : (
                  <span className="building-damages__no__flood__text">
                    No buildings detected
                  </span>
                )}
            </div>
          )}
          
        </div>
      )}
      {isPrintTriggered && <Print changeTriggerStatus={setIsPrintTriggered} />}
    </div>
  );
}

export default BuildingDamages;